export enum OutputFormat {
    WEBM_BLOB_URL,
    WEBM_BLOB,
}